export const FERRY_INGREDIENT_SUFFIX = 'fe';
